/*
 * @Descripttion: 短信免责声明弹窗
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React from 'react';
import { Bixi } from '@open-fxg/bixi-react';
import Cookie from 'js-cookie';
import { Servlets } from '@/service';

const DisclaimerDialog = () => {
  const [options, setOptions] = React.useState({
    appId: '6943091080690714152',
    shopId: Cookie.get('shopId'),
    componentId: 369,
    token: ''
  });
  const getToken = async () => {
    await Servlets('getDyToken').then((res) => {
      if (!res.success) {
        return;
      }
      setOptions({
        ...options,
        token: res.data
      })
    })
      .catch((err) => {
        console.log(err);
      });
  };
  React.useEffect(() => {
    getToken();
  }, []);
  return (<>
    {options.token ? <Bixi {...options} /> : <></>}
    </>
  )
};
export default DisclaimerDialog;
